



































































import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { PaginationModel, VAction, VHeaders } from "@/models/pagedlistmodel";
import { attachmentService, jobRequisitionService } from "@/shared";
import { Component } from "vue-property-decorator";

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})

export default class ApplicantListPage extends Base {
    public loading:boolean = false;
    public filesLoading:boolean = false;
    public pagination = new PaginationModel('candidateId');
    public applicantHeaders:VHeaders[] = [];
    public applicantActions:VAction[] = 
    [
        // {
        //     type: "anchor",
        //     icon: "fas fa-link",
        //     title: "Profile Link",
        //     color: 'primary',
        //     action: (model) => {
        //         return model.candidateUrl;
        //     },
        // },
        {
            type: "button",
            icon: "fas fa-paperclip",
            title: "View Attachments",
            color: 'primary',
            action: (model) => {
                this.viewApplicantAttachments(model);
            }
        },
    ];
    
    public filesActions:any[] = [];
    public filesHeaders:VHeaders[] = [];
    public applicantItems: any[] = [];
    public applicantFiles: any[] = [];
    public jobId:number;
    public candidateId:number;
    public applicantFilter:string;
    public applicantFilters: any[] = [
        { value: "CandidateId", text: "Candidate Id" },
        { value: "CandidateName", text: "Candidate Name" },
        { value: "CandidateEmail", text: "Candidate Email" },
    ];

    public attachmentDialog: IDialogOption = {
        width: 500,
        title: "Attachments",
        model: false,
    };

    public mounted(){
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'hierologyJobs');

        this.setApplicantHeaders();
        this.jobId =  Number(this.$route.params.jobId);
        this.candidateId =  Number(this.$route.params.candidateId);
        this.updateToolBar();
        this.setFilesHeaders();
        this.setFilesActions();
        
        if(this.candidateId)
        {
           this.applicantFilter = "CandidateId";
           this.pagination.search = this.candidateId.toString();
        }
        this.getApplicants();

        this.$watch("methodtoCall", (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
    }


    public updateToolBar(): void {
        const buttons: any = [];

        buttons.push({
            id: "1",
            type: "button",
            title: "Back to List",
            disabled: false,
            visible: true,
            class: "btn",
            label: "Back to List",
            click: "backToList",
            icon: "fas fa-arrow-left",
            requestProgress: true,
        });

        this.$emit("updateToolBar", buttons);
    }

    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            history.back();
        }
    } 

    public beforeDestroy() {
        const buttons = [];
        this.$emit("updateToolBar", buttons);
    }

    public setApplicantHeaders(){
        this.applicantHeaders = 
        [
            {
                text: 'Description',
                align: 'left',
                isNotDataProp: true,
                sortable: false,
            },
            {
                text: "Candidate Id",
                align: "left",
                sortable: true,
                value: "candidateId",
            },
            {
                text: "Candidate Name",
                align: "left",
                sortable: false,
                value: "candidateName",
            },
            {
                text: "Candidate Email",
                align: "left",
                sortable: false,
                value: "candidateEmail",
            },
            {
                text: "Candidate Phone No",
                align: "left",
                sortable: false,
                value: "candidatePhoneNo",
            },
            {
                align: 'center',
                text: "Actions",
                isNotDataProp: true,
                sortable: false,
            }
        ];
    }

    public setFilesHeaders() {
        this.filesHeaders = [
            {
                text: "Attachment Type",
                align: "left",
                sortable: true,
                value: "fileName",
            },
            {
                align: 'center',
                text: "Actions",
                isNotDataProp: true,
                sortable: false,
            },
        ];
    }    


    public setFilesActions() {
        this.filesActions = 
        [
            {
                type: "button",
                icon: "fas fa-eye",
                title: "View Attachment",
                color: 'primary',
                action: (model) => {
                    this.viewAttachments(model.fileLocation);

                   // window.open(model.fileLocation, "_blank") ;
                },
            }
        ];
    }

    public async viewAttachments(uri){
        const attachment = await attachmentService.viewAttachmentByUriAsync(
        uri
      );
    }

    public async viewApplicantAttachments(model){
       try{
            this.attachmentDialog.model = true;
            this.filesLoading = true;
            var response = await jobRequisitionService.getAttachments(model.candidateId);
            
            this.applicantFiles = response.results;
        }finally{
            this.filesLoading = false;
       }
    }

    public async getApplicants(){
        try{
            if(this.jobId){
                this.loading = true;
                var response = await jobRequisitionService.getApplicants(this.pagination, this.jobId, this.applicantFilter);
                this.applicantItems = response.results;
                this.pagination.totalItems = response.total;
                this.setApplicantHeaders();
            }
        }finally{
            this.loading = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
        this.getApplicants();
    }
}


